import Link from 'next/link';

import { faSignOut } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAuth } from 'hooks/useAuth';

import routes from 'config/routes';

import { Wrapper } from 'components/atom/Grid';
import Logo from 'components/atom/Logo';

import { ActionsContainer, ButtonAction, Container } from './styles';

const Header: React.FC = () => {
  const { signOut } = useAuth();

  return (
    <Container>
      <Wrapper>
        <Link href={routes.home}>
          <Logo />
        </Link>

        <ActionsContainer>
          <ButtonAction onClick={() => signOut()}>
            <FontAwesomeIcon icon={faSignOut} />
          </ButtonAction>
        </ActionsContainer>
      </Wrapper>
    </Container>
  );
};

export default Header;
